import React from 'react';
import { IconProps } from './types';

export const SpotIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.21786 14.5299C4.1264 13.5227 2.68164 11.383 2.68164 8.91399C2.68164 5.4774 5.47764 2.68182 8.91517 2.68182C11.3846 2.68182 13.5226 4.12617 14.5297 6.21726C10.06 6.47181 6.47117 10.0629 6.21786 14.5299Z'
        stroke={color}
      />
      <path
        d='M15.2743 9.22728C15.3845 9.22728 15.495 9.23105 15.6063 9.23757L15.7969 9.25397C18.887 9.51981 21.3184 12.117 21.3184 15.2727C21.3184 18.6064 18.6062 21.3182 15.2717 21.3182C12.118 21.3182 9.51788 18.8849 9.25169 15.7984C9.23694 15.6212 9.22754 15.4466 9.22754 15.2727C9.22754 11.9391 11.9398 9.22728 15.2743 9.22728Z'
        stroke={color}
      />
      <path
        d='M16.3633 4.36363L19.636 7.63636V5.76533'
        stroke='#DFF60D'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path
        d='M7.63601 19.6364L4.36328 16.3636V18.2347'
        stroke='#DFF60D'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
    </svg>
  );
};
